import $ from "cash-dom";
export default function InitProductList() {
    $('[data-action-expand-level]').on('click', function() {
        $(this).closest('[data-active-level]').data('active-level', $(this).data('action-expand-level'));
        $(this).closest('[data-level]').addClass('active');
    });

    $('[data-action-collapse-to-level]').on('click', function() {
        $(this).closest('[data-active-level]').data('active-level', $(this).data('action-collapse-to-level'));
        $(this).closest('[data-level]').removeClass('active');
    });

    $('.product-list__item--structured .product__label').each(function(){
        const $productLabel = $(this);
        const productNumber = $productLabel.text().includes(' ') && $productLabel.text().match(/(^\S+)/) ? $productLabel.text().match(/(^\S+)/)[0] : '';
        $productLabel.html($productLabel.html().replace(productNumber,`<strong>${productNumber}</strong>`) );
    });
}
